import React from 'react'
import BottomNav from './BottomNav'

export default ({ modal }) => (
	<div style={{ position: 'fixed', bottom: modal ? 54 : 0, left: 0 }}>
		<BottomNav />
	</div>
)
